import axios from "axios";

class UserService {

  static async loginAPI(emailAddress, mobileNumber, password) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios
        .post(`${url}/api/v1/pub/sign-in`, {
          emailAddress,
          mobileNumber,
          password,
        })
        .catch((error) => {
          console.log("an exception has been occured.", error);
          throw error;
        });
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  static async register(userData, token) {
    try {
      
    } catch (error) {

    }
  }

  static async getAllUsers(token, type) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/get-drivers?status=ACTIVE&type=`+type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getYourProfile(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.post(
        `${url}api/v1/pri/web/get-vehicle?rego=TEST001`,
        {
          headers: { Authorization: `Bearer${token}` },
        }
      );
      return response.data;
    } catch (error) {}
  }

  static async getUserbyId(userId, token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.post(
        `${url}api/v1/pri/web/get-vehicle?rego=TEST001`,
        {
          headers: { Authorization: `Bearer${token}` },
        }
      );
      return response.data;
    } catch (error) {}
  }

  static logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
  }

  static isAuthenticated() {
    const token = localStorage.getItem("token");
    return !!token;
  }

  static isUser() {
    const role = localStorage.getItem("role");
    return role === "USER";
  }

  static isAdmin() {
    const role = localStorage.getItem("role");
    return role === "ADMIN";
  }

  static adminOnly() {
    return this.isAuthenticated() && this.isAdmin();
  }

  static validateEmail (email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
}



export default UserService;
